import { Divider, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import { Link } from 'react-router-dom';

import s from './Footer.module.scss';

function Footer() {
  return (
    <footer className={s.footer}>
      <div className={s.footerInner}>
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-10">
          {/* Brand */}
          <div>
            <Title
              order={3}
              mb="sm"
              sx={{
                background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              FlowBoard
            </Title>
            <Text size="sm" sx={{ color: 'rgba(255,255,255,0.4)' }}>
              Streamline your projects with confidence.
            </Text>
          </div>

          {/* Product */}
          <div>
            <div className={s.footerHeading}>Product</div>
            <Stack spacing={8}>
              <Link to="/how-it-works" className={s.footerLink}>How it works</Link>
              <Link to="/features" className={s.footerLink}>Features</Link>
              <Link to="/pricing" className={s.footerLink}>Pricing</Link>
              <Link to="/integrations" className={s.footerLink}>Integrations</Link>
              <Link to="/use-cases" className={s.footerLink}>Use Cases</Link>
              <Link to="/testimonials" className={s.footerLink}>Testimonials</Link>
            </Stack>
          </div>

          {/* Company */}
          <div>
            <div className={s.footerHeading}>Company</div>
            <Stack spacing={8}>
              <Link to="/about" className={s.footerLink}>About us</Link>
              <Link to="/contact" className={s.footerLink}>Contact us</Link>
              <Link to="/login" className={s.footerLink}>Sign in</Link>
              <Link to="/request-access" className={s.footerLink}>Request access</Link>
            </Stack>
          </div>

          {/* Legal */}
          <div>
            <div className={s.footerHeading}>Legal</div>
            <Stack spacing={8}>
              <Link to="/privacy" className={s.footerLink}>Privacy Policy</Link>
              <Link to="/terms" className={s.footerLink}>Terms & Conditions</Link>
              <Link to="/cookies" className={s.footerLink}>Cookie Policy</Link>
            </Stack>
          </div>
        </div>

        <Divider my="xl" sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />

        <Text ta="center" size="sm" sx={{ color: 'rgba(255,255,255,0.3)' }}>
          &copy;
          {' '}
          {new Date().getFullYear()}
          {' '}
          FlowBoard. All rights reserved.
        </Text>
      </div>
    </footer>
  );
}

export default Footer;
